import axios from 'axios';

const _raw = process.env.REACT_APP_API_URL || 'http://localhost:8000';
const API_URL = (window.location.protocol === 'https:' && _raw.startsWith('http://'))
  ? _raw.replace('http://', 'https://')
  : _raw;
const api = axios.create({ baseURL: API_URL });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export const authApi = {
  login: (username: string, password: string) =>
    api.post('/api/token', new URLSearchParams({ username, password })),
  verifyOtp: (kullanici_adi: string, otp: string) =>
    api.post('/api/token/dogrula', new URLSearchParams({ kullanici_adi, otp })),
  me: () => api.get('/api/me'),
};

export const isletmeApi = {
  list: (tumu = false) => api.get('/api/isletmeler/', { params: { tumu } }),
  get: (id: number) => api.get(`/api/isletmeler/${id}`),
  create: (data: any) => api.post('/api/isletmeler/', data),
  update: (id: number, data: any) => api.put(`/api/isletmeler/${id}`, data),
  delete: (id: number) => api.delete(`/api/isletmeler/${id}`),
};

export const kullaniciApi = {
  list: () => api.get('/api/kullanicilar/'),
  create: (data: any) => api.post('/api/kullanicilar/', data),
  update: (id: number, data: any) => api.put(`/api/kullanicilar/${id}`, data),
  sifreDegistir: (id: number, sifre: string) => api.put(`/api/kullanicilar/${id}/sifre`, { yeni_sifre: sifre }),
  delete: (id: number) => api.delete(`/api/kullanicilar/${id}`),
  personelAra: (q: string, tc?: string) => api.get('/api/kullanicilar/personel-ara', { params: tc ? { tc } : { q } }),
};

export const tanimlarApi = {
  kullaniciListesi: () => api.get('/api/kullanicilar/'),
  dashboard: () => api.get('/api/tanimlar/dashboard'),
  roller: () => api.get('/api/tanimlar/roller'),
  isletmelerListesi: (kiralikGoster = false) => api.get('/api/tanimlar/isletmeler-listesi', { params: { kiralik_goster: kiralikGoster } }),
  orgBirimlerListesi: () => api.get('/api/org-yapisi/birimler-listesi'),
};

export const hayvancılikApi = {
  buyukbasList: (params?: any) => api.get('/api/hayvancilik/buyukbas', { params }),
  buyukbasSave: (data: any) => api.post('/api/hayvancilik/buyukbas', data),
  buyukbasDelete: (id: number) => api.delete(`/api/hayvancilik/buyukbas/${id}`),
  buyukbasOzet: (params: any) => api.get('/api/hayvancilik/buyukbas/ozet', { params }),
  buyukbasExcel: (file: File, cakisma = '') => {
    const fd = new FormData(); fd.append('file', file); fd.append('cakisma', cakisma);
    return api.post('/api/hayvancilik/buyukbas/excel-import', fd);
  },
  kucukbasList: (params?: any) => api.get('/api/hayvancilik/kucukbas', { params }),
  kucukbasSave: (data: any) => api.post('/api/hayvancilik/kucukbas', data),
  kucukbasDelete: (id: number) => api.delete(`/api/hayvancilik/kucukbas/${id}`),
  kucukbasOzet: (params: any) => api.get('/api/hayvancilik/kucukbas/ozet', { params }),
  kucukbasExcel: (file: File, cakisma = '') => {
    const fd = new FormData(); fd.append('file', file); fd.append('cakisma', cakisma);
    return api.post('/api/hayvancilik/kucukbas/excel-import', fd);
  },
};

export const referansDonemApi = {
  liste: (isletme_id?: number) => api.get('/api/referans-donem', { params: isletme_id ? { isletme_id } : undefined }),
  toplu: (yil: number, referans_ay: number) => api.post('/api/referans-donem/toplu', { yil, referans_ay }),
  tek: (isletme_id: number, yil: number) => api.get(`/api/referans-donem/${isletme_id}/${yil}`),
  kaydet: (data: { isletme_id: number; yil: number; referans_ay: number }) => api.post('/api/referans-donem', data),
  sil: (isletme_id: number, yil: number) => api.delete(`/api/referans-donem/${isletme_id}/${yil}`),
  benim: (yil: number) => api.get(`/api/referans-donem/benim/${yil}`),
};

export const isTakipApi = {
  // Referans
  personelListesi:  () => api.get('/api/is-takip/referans/personel'),
  birimListesi:     () => api.get('/api/is-takip/referans/birimler'),
  isletmeListesi:   () => api.get('/api/is-takip/referans/isletmeler'),
  // Konular
  konularListe:     (params?: any) => api.get('/api/is-takip/konular', { params }),
  konuDetay:        (id: number)   => api.get(`/api/is-takip/konular/${id}`),
  konuOlustur:      (data: any)    => api.post('/api/is-takip/konular', data),
  konuGuncelle:     (id: number, data: any) => api.put(`/api/is-takip/konular/${id}`, data),
  konuSil:          (id: number)   => api.delete(`/api/is-takip/konular/${id}`),
  // Eylemler
  eylemOlustur:     (data: any)    => api.post('/api/is-takip/eylemler', data),
  eylemGuncelle:    (id: number, data: any) => api.put(`/api/is-takip/eylemler/${id}`, data),
  eylemSil:         (id: number)   => api.delete(`/api/is-takip/eylemler/${id}`),
  // Toplantılar
  toplantilarListe: (params?: any) => api.get('/api/is-takip/toplantilar', { params }),
  toplantıDetay:    (id: number)   => api.get(`/api/is-takip/toplantilar/${id}`),
  toplantıOlustur:  (data: any)    => api.post('/api/is-takip/toplantilar', data),
  toplantıGuncelle: (id: number, data: any) => api.put(`/api/is-takip/toplantilar/${id}`, data),
  toplantıSil:      (id: number)   => api.delete(`/api/is-takip/toplantilar/${id}`),
  // Kararlar
  kararEkle:        (toplantıId: number, data: any) => api.post(`/api/is-takip/toplantilar/${toplantıId}/kararlar`, data),
  kararGuncelle:    (id: number, data: any) => api.put(`/api/is-takip/kararlar/${id}`, data),
  kararSil:         (id: number)   => api.delete(`/api/is-takip/kararlar/${id}`),
  // Pano & Bildirimler
  pano:             () => api.get('/api/is-takip/pano'),
  bildirimler:      () => api.get('/api/is-takip/bildirimler'),
  bildirimlerDetay: () => api.get('/api/is-takip/bildirimler/detay'),
};

export const eskPartiApi = {
  // Partiler
  partilerListe:     (params?: any) => api.get('/api/esk-parti/partiler', { params }),
  partiDetay:        (id: number)   => api.get(`/api/esk-parti/partiler/${id}`),
  partiOlustur:      (data: any)    => api.post('/api/esk-parti/partiler', data),
  partiGuncelle:     (id: number, data: any) => api.put(`/api/esk-parti/partiler/${id}`, data),
  partiSil:          (id: number)   => api.delete(`/api/esk-parti/partiler/${id}`),
  // Detay (1:1 upsert)
  besilikDetaySave:  (partiId: number, data: any) => api.put(`/api/esk-parti/partiler/${partiId}/besilik-detay`, data),
  // Buzağı Satışı
  buzagiSatisEkle:      (partiId: number, data: any) => api.post(`/api/esk-parti/partiler/${partiId}/buzagi-satis`, data),
  buzagiSatisGuncelle:  (id: number, data: any) => api.put(`/api/esk-parti/buzagi-satis/${id}`, data),
  buzagiSatisSil:       (id: number) => api.delete(`/api/esk-parti/buzagi-satis/${id}`),
  // Yem Desteği
  yemDestegiEkle:      (partiId: number, data: any) => api.post(`/api/esk-parti/partiler/${partiId}/yem-destegi`, data),
  yemDestegiGuncelle:  (id: number, data: any) => api.put(`/api/esk-parti/yem-destegi/${id}`, data),
  yemDestegiSil:       (id: number) => api.delete(`/api/esk-parti/yem-destegi/${id}`),
  // Tarsım
  tarsimEkle:      (partiId: number, data: any) => api.post(`/api/esk-parti/partiler/${partiId}/tarsim`, data),
  tarsimGuncelle:  (id: number, data: any) => api.put(`/api/esk-parti/tarsim/${id}`, data),
  tarsimSil:       (id: number) => api.delete(`/api/esk-parti/tarsim/${id}`),
  // Kalan Boş Düve (kesim / canlı iade)
  bosDuveEkle:      (partiId: number, data: any) => api.post(`/api/esk-parti/partiler/${partiId}/bos-duve`, data),
  bosDuveGuncelle:  (id: number, data: any) => api.put(`/api/esk-parti/bos-duve/${id}`, data),
  bosDuveSil:       (id: number) => api.delete(`/api/esk-parti/bos-duve/${id}`),
  // Bakım Desteği Verilmeyen Hayvan Sayısı
  bakimDestegiVerilmeyenEkle:      (partiId: number, data: any) => api.post(`/api/esk-parti/partiler/${partiId}/bakim-destegi-verilmeyen`, data),
  bakimDestegiVerilmeyenGuncelle:  (id: number, data: any) => api.put(`/api/esk-parti/bakim-destegi-verilmeyen/${id}`, data),
  bakimDestegiVerilmeyenSil:       (id: number) => api.delete(`/api/esk-parti/bakim-destegi-verilmeyen/${id}`),
  // Satış çağrıları
  satisCagrisiEkle:      (partiId: number, data: any) => api.post(`/api/esk-parti/partiler/${partiId}/satis-cagrilari`, data),
  satisCagrisiGuncelle:  (id: number, data: any) => api.put(`/api/esk-parti/satis-cagrilari/${id}`, data),
  satisCagrisiSil:       (id: number) => api.delete(`/api/esk-parti/satis-cagrilari/${id}`),
  // Aylık bakım
  aylikBakimEkle:     (partiId: number, data: any) => api.post(`/api/esk-parti/partiler/${partiId}/aylik-bakim`, data),
  aylikBakimGuncelle: (id: number, data: any) => api.put(`/api/esk-parti/aylik-bakim/${id}`, data),
  aylikBakimSil:      (id: number) => api.delete(`/api/esk-parti/aylik-bakim/${id}`),
  // Çıkış kayıtları (ölen/kesim/canlı iade/teslim tutanağı)
  cikisKaydiEkle:     (partiId: number, data: any) => api.post(`/api/esk-parti/partiler/${partiId}/cikis-kayitlari`, data),
  cikisKaydiGuncelle: (id: number, data: any) => api.put(`/api/esk-parti/cikis-kayitlari/${id}`, data),
  cikisKaydiSil:      (id: number) => api.delete(`/api/esk-parti/cikis-kayitlari/${id}`),
  // Ödeme planı (vadeli satış)
  odemePlaniGetir:  (partiId: number) => api.get(`/api/esk-parti/partiler/${partiId}/odeme-plani`),
  odemeKaydet:      (taksitId: number, data: any) => api.put(`/api/esk-parti/odeme-plani/${taksitId}`, data),
  // Özet / kâr-zarar
  partiOzet:        (id: number) => api.get(`/api/esk-parti/partiler/${id}/ozet`),
  isletmeOzet:      (params?: any) => api.get('/api/esk-parti/isletme-ozet', { params }),
  projeOzet:        (params?: any) => api.get('/api/esk-parti/proje-ozet', { params }),
  // Parametreler
  parametreler:         (yil: number) => api.get('/api/esk-parti/parametreler', { params: { yil } }),
  parametreGuncelle:    (yil: number, data: any) => api.put(`/api/esk-parti/parametreler/${yil}`, data),
};

export default api;
